/* HeyBear · The difference: robbers run away from the cop as you scroll. */
HB.section('difference', function (root) {
  HB.reveal(root);
  if (!HB.gsapReady()) return;
  var tw = gsap.fromTo(root.querySelector('#robbers'), { xPercent: -30 }, { xPercent: 4, ease: 'none', scrollTrigger: { trigger: root.querySelector('#chase'), start: 'top 90%', end: 'bottom 20%', scrub: true } });
  return function () { tw.scrollTrigger && tw.scrollTrigger.kill(); tw.kill(); };
});
